import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConvertibilityConvertible = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "convertibility-convertible",
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17537",
		"data-name": "Group 17537",
		transform: "translate(2 4.667)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path_13023",
			"data-name": "Path 13023",
			d: "M9.667,13H9c-3.314,0-6-1.343-6-3S5.686,7,9,7s6,1.343,6,3c0,1.04-1.059,1.956-2.667,2.494C13.941,11.956,15,11.04,15,10c0-1.657-2.686-3-6-3S3,8.343,3,10s2.686,3,6,3",
			transform: "translate(-3 -7)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_13024",
			"data-name": "Path 13024",
			d: "M10.5,16.833l1.667-1.667L10.5,13.5",
			transform: "translate(-5.5 -9.167)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		})]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_13025",
		"data-name": "Path 13025",
		d: "M0,0H16V16H0Z",
		fill: "none"
	})]
});
export default SvgConvertibilityConvertible;
